export default __webpack_public_path__ + "static/B0129-8d5c8ea342ab2f6fee887fe315602ee2.png";